const NeighborhoodsSection = () => {
  const neighborhoods = [
    {
      name: 'West El Paso',
      description: 'From Coronado Hills to Canutillo, we buy homes throughout West El Paso, including properties near UTEP and the scenic Upper Valley.',
      icon: 'ri-map-pin-2-line'
    },
    {
      name: 'East El Paso',
      description: 'Serving Mission Valley, Eastwood, Montana Vista, and Horizon City with fast cash offers for homes in any condition.',
      icon: 'ri-map-pin-3-line'
    },
    {
      name: 'Central El Paso',
      description: 'Buying properties in Downtown, Kern Place, Sunset Heights, and surrounding historic neighborhoods.',
      icon: 'ri-map-pin-4-line'
    },
    {
      name: 'Northeast El Paso',
      description: 'Active in Cimarron, Tierra Del Sol, and areas near Fort Bliss, providing solutions for military families and civilians alike.',
      icon: 'ri-map-pin-5-line'
    },
    {
      name: 'Lower Valley',
      description: 'Purchasing homes in Socorro, San Elizario, Clint, and Fabens, serving the agricultural communities of the Lower Valley.',
      icon: 'ri-map-pin-line'
    },
    {
      name: 'Westside',
      description: 'Buying properties in Sunland Park, Santa Teresa, and the growing communities along the New Mexico border.',
      icon: 'ri-map-pin-user-line'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-6 text-gray-900">
            We Buy Homes in <strong>All El Paso Neighborhoods</strong>
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            No matter where your property is located in El Paso County, we're interested in making you a fair cash offer.
          </p>
        </div>

        <div className="mb-16">
          <img
            src="https://public.readdy.ai/ai/img_res/f86d4e8f6044b9031ce84aeaf180cfff.jpg"
            alt="El Paso neighborhoods panorama"
            className="w-full h-96 object-cover rounded-xl shadow-xl"
          />
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          {neighborhoods.map((neighborhood, index) => (
            <div key={index} className="bg-gradient-to-br from-gray-50 to-white rounded-xl shadow-lg p-8 hover:shadow-xl transition-shadow">
              <div className="w-14 h-14 bg-teal-100 rounded-lg flex items-center justify-center mb-4">
                <i className={`${neighborhood.icon} text-3xl text-teal-600`}></i>
              </div>
              <h3 className="text-2xl font-bold mb-3 text-gray-900">{neighborhood.name}</h3>
              <p className="text-gray-700 leading-relaxed">{neighborhood.description}</p>
            </div>
          ))}
        </div>

        <div className="bg-teal-50 rounded-xl p-8 md:p-12">
          <h3 className="text-3xl font-bold mb-6 text-gray-900 text-center">
            Understanding El Paso's Diverse Communities
          </h3>
          <div className="grid md:grid-cols-2 gap-8">
            <div>
              <p className="text-lg text-gray-700 mb-4 leading-relaxed">
                El Paso is a city of remarkable diversity, with neighborhoods ranging from historic downtown districts to modern suburban developments. Each area has its own character, challenges, and opportunities. Our extensive experience across all these communities means we understand what makes each neighborhood unique.
              </p>
              <p className="text-lg text-gray-700 leading-relaxed">
                Whether your property is a historic adobe home in Sunset Heights, a mid-century ranch in the Northeast, or a newer construction in Eastlake, we have the expertise to evaluate it fairly. We consider factors like school districts, proximity to employment centers, neighborhood amenities, and future development plans when making our offers.
              </p>
            </div>
            <div>
              <p className="text-lg text-gray-700 mb-4 leading-relaxed">
                We're particularly familiar with the challenges facing different areas. Properties near Fort Bliss may need quick sales due to military relocations. Homes in the Lower Valley might face unique title or access issues. Historic properties downtown may have preservation considerations. Whatever the situation, we've handled it before.
              </p>
              <p className="text-lg text-gray-700 leading-relaxed">
                Our commitment extends beyond just buying homes. We're invested in the revitalization and improvement of El Paso neighborhoods. Many properties we purchase are renovated and returned to the market, helping to strengthen communities and provide quality housing options for El Paso families.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default NeighborhoodsSection;
